module.exports = __webpack_public_path__ + "static/media/DSC01790.cc0c8b63.jpeg";